export const SET_LOCATIONS="app/locationsList/SET_LOCATIONS"
